import "~/misc/common";
import { loader } from "~/misc/common";
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    console.log('initImportFile');
    $("#file_uri").on('change', function () {
      loader(true);
      $('form.file').trigger('submit');
    });
  }
}